/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArrayMeetingType,
  ArrayMeetingTypeDraft,
  ArrayNewReminder,
  ArrayReminder,
  DataFieldRef,
  JsonObject,
  MapMeetingTypeIdPublicMeetingType,
  MapString,
  MeetingTypeDraft,
  MeetingTypePasswordValidation,
  MeetingTypeWithReminders,
  MeetingTypesBatchDto,
  NewMeetingTypeWithDefaults,
  NewReminder,
  PublicMeetingType,
  Reminder,
  TypeOfMeetingType,
  UsageBulkRequestTapirCodecsSchemaForUsageBulkRequestRes,
  UsageRequestTapirCodecsSchemaForUsageRequestRes,
  WrappedLeaseTapirCodecsSchemaForWrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meeting-types";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Attempts to get a meeting type by the specified id
   *
   * @tags Meeting Type / CRUD
   * @name GetMeetingTypeGlobally
   * @request GET:/v1/tenant/{tenantId}/meeting-type/{meetingTypeId}
   * @secure
   */
  getMeetingTypeGlobally = (tenantId: string, meetingTypeId: string, params: RequestParams = {}) =>
    this.request<
      MeetingTypeWithReminders,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meeting-type/${meetingTypeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingTypeGlobally */
  getMeetingTypeGloballyPathGetter = (tenantId: string, meetingTypeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/meeting-type/${meetingTypeId}`);

  /**
   * @description Attempts to get meeting types by the specified ids. Does not fail if meeting type is missing.
   *
   * @tags Meeting Type / CRUD
   * @name GetMeetingTypesGlobally
   * @request GET:/v1/tenant/{tenantId}/meeting-types-batch
   * @secure
   */
  getMeetingTypesGlobally = (
    tenantId: string,
    query?: {
      /** List of meeting type ids */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypesBatchDto,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/meeting-types-batch`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingTypesGlobally */
  getMeetingTypesGloballyPathGetter = (
    tenantId: string,
    query?: {
      /** List of meeting type ids */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/meeting-types-batch`, query);

  /**
   * @description Attempts to find a meeting type by the specified id
   *
   * @tags Meeting Type / CRUD
   * @name FindMeetingType
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type/{meetingTypeId}
   * @secure
   */
  findMeetingType = (tenantId: string, workspaceId: string, meetingTypeId: string, params: RequestParams = {}) =>
    this.request<
      MeetingTypeWithReminders,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findMeetingType */
  findMeetingTypePathGetter = (tenantId: string, workspaceId: string, meetingTypeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`);

  /**
   * @description Deletes the meeting type using the specified id
   *
   * @tags Meeting Type / CRUD
   * @name DeleteMeetingType
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type/{meetingTypeId}
   * @secure
   */
  deleteMeetingType = (tenantId: string, workspaceId: string, meetingTypeId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteMeetingType */
  deleteMeetingTypePathGetter = (tenantId: string, workspaceId: string, meetingTypeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}`);

  /**
   * @description Creates a meeting type and returns the object with the assigned identifier.
   *
   * @tags Meeting Type / CRUD
   * @name CreateMeetingType
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type
   * @secure
   */
  createMeetingType = (
    tenantId: string,
    workspaceId: string,
    data: NewMeetingTypeWithDefaults,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypeWithReminders,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createMeetingType */
  createMeetingTypePathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type`);

  /**
   * @description Returns a list of meeting types matching the query
   *
   * @tags Meeting Type / Queries
   * @name FindMeetingTypes
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-types
   * @secure
   */
  findMeetingTypes = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** selects all meeting type headers which name field contains the parameter */
      name?: string;
      /**
       * selects all meeting type headers that have a reference to the specified reminder
       * @pattern [^\s\\/]+
       */
      "reminder-id"?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayMeetingType,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findMeetingTypes */
  findMeetingTypesPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** selects all meeting type headers which name field contains the parameter */
      name?: string;
      /**
       * selects all meeting type headers that have a reference to the specified reminder
       * @pattern [^\s\\/]+
       */
      "reminder-id"?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-types`, query);

  /**
   * @description Duplicates a meeting type and returns the duplicated object with the assigned identifier.
   *
   * @tags Meeting Type / CRUD
   * @name DuplicateMeetingType
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type/{meetingTypeId}/duplicate
   * @secure
   */
  duplicateMeetingType = (
    tenantId: string,
    workspaceId: string,
    meetingTypeId: string,
    query: {
      /** @minLength 1 */
      duplicateName: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypeWithReminders,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}/duplicate`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for duplicateMeetingType */
  duplicateMeetingTypePathGetter = (
    tenantId: string,
    workspaceId: string,
    meetingTypeId: string,
    query: {
      /** @minLength 1 */
      duplicateName: string;
    },
  ) =>
    this.getServicePath(
      `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type/${meetingTypeId}/duplicate`,
      query,
    );

  /**
   * @description Removes the reminder given by the specified reminderId from all meeting types that are using it
   *
   * @tags Meeting Type / Actions
   * @name RemoveReminderFromMeetingTypes
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-types/reminder/{reminderId}
   * @secure
   */
  removeReminderFromMeetingTypes = (
    tenantId: string,
    workspaceId: string,
    reminderId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-types/reminder/${reminderId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for removeReminderFromMeetingTypes */
  removeReminderFromMeetingTypesPathGetter = (tenantId: string, workspaceId: string, reminderId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-types/reminder/${reminderId}`);

  /**
   * @description Returns a list of meeting type drafts matching the query
   *
   * @tags Meeting Type Draft / CRUD
   * @name FindMeetingTypeDrafts
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type-drafts
   * @secure
   */
  findMeetingTypeDrafts = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** selects all meeting type drafts which name field contains the parameter */
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayMeetingTypeDraft,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findMeetingTypeDrafts */
  findMeetingTypeDraftsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query?: {
      /** selects all meeting type drafts which name field contains the parameter */
      name?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts`, query);

  /**
   * @description Creates a meeting type draft and returns the object with the assigned identifier
   *
   * @tags Meeting Type Draft / CRUD
   * @name CreateMeetingTypeDraft
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type-drafts
   * @secure
   */
  createMeetingTypeDraft = (tenantId: string, workspaceId: string, data: JsonObject, params: RequestParams = {}) =>
    this.request<
      MeetingTypeDraft,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createMeetingTypeDraft */
  createMeetingTypeDraftPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts`);

  /**
   * @description Upsert a meeting type draft
   *
   * @tags Meeting Type Draft / CRUD
   * @name UpsertMeetingTypeDraft
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type-drafts/{meetingTypeId}
   * @secure
   */
  upsertMeetingTypeDraft = (
    tenantId: string,
    workspaceId: string,
    meetingTypeId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: JsonObject,
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypeDraft,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts/${meetingTypeId}`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertMeetingTypeDraft */
  upsertMeetingTypeDraftPathGetter = (
    tenantId: string,
    workspaceId: string,
    meetingTypeId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts/${meetingTypeId}`, query);

  /**
   * @description Deletes the meeting type draft using the specified id
   *
   * @tags Meeting Type Draft / CRUD
   * @name DeleteMeetingTypeDraft
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/meeting-type-drafts/{meetingTypeId}
   * @secure
   */
  deleteMeetingTypeDraft = (tenantId: string, workspaceId: string, meetingTypeId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts/${meetingTypeId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteMeetingTypeDraft */
  deleteMeetingTypeDraftPathGetter = (tenantId: string, workspaceId: string, meetingTypeId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/meeting-type-drafts/${meetingTypeId}`);

  /**
   * @description Attempts to find a reminder by the specified id
   *
   * @tags Reminder / CRUD
   * @name FindReminder
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/reminder/{reminderId}
   * @secure
   */
  findReminder = (tenantId: string, workspaceId: string, reminderId: string, params: RequestParams = {}) =>
    this.request<
      Reminder,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder/${reminderId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findReminder */
  findReminderPathGetter = (tenantId: string, workspaceId: string, reminderId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder/${reminderId}`);

  /**
   * @description Deletes the reminder
   *
   * @tags Reminder / CRUD
   * @name DeleteReminder
   * @request DELETE:/v1/tenant/{tenantId}/workspace/{workspaceId}/reminder/{reminderId}
   * @secure
   */
  deleteReminder = (tenantId: string, workspaceId: string, reminderId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder/${reminderId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteReminder */
  deleteReminderPathGetter = (tenantId: string, workspaceId: string, reminderId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder/${reminderId}`);

  /**
   * @description Returns reminders within the specified workspace id
   *
   * @tags Reminder / Queries
   * @name FindReminders
   * @request GET:/v1/tenant/{tenantId}/workspace/{workspaceId}/reminders
   * @secure
   */
  findReminders = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      ArrayReminder,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reminders`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findReminders */
  findRemindersPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reminders`);

  /**
   * @description Returns reminders template
   *
   * @tags Reminder / Queries
   * @name FindRemindersTemplates
   * @request GET:/v1/tenant/{tenantId}/reminders/templates
   * @secure
   */
  findRemindersTemplates = (
    tenantId: string,
    query: {
      /** the type of meeting types the reminder will be attached to */
      typeOfMeetingType: TypeOfMeetingType;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayNewReminder,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/reminders/templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findRemindersTemplates */
  findRemindersTemplatesPathGetter = (
    tenantId: string,
    query: {
      /** the type of meeting types the reminder will be attached to */
      typeOfMeetingType: TypeOfMeetingType;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/reminders/templates`, query);

  /**
   * @description Updates reminder using given payload
   *
   * @tags Reminder / CRUD
   * @name UpdateReminder
   * @request PUT:/v1/tenant/{tenantId}/workspace/{workspaceId}/reminder
   * @secure
   */
  updateReminder = (tenantId: string, workspaceId: string, data: Reminder, params: RequestParams = {}) =>
    this.request<
      Reminder,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateReminder */
  updateReminderPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder`);

  /**
   * @description Creates a new Reminder using given payload within the specified workspace
   *
   * @tags Reminder / CRUD
   * @name CreateReminder
   * @request POST:/v1/tenant/{tenantId}/workspace/{workspaceId}/reminder
   * @secure
   */
  createReminder = (tenantId: string, workspaceId: string, data: NewReminder, params: RequestParams = {}) =>
    this.request<
      Reminder,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createReminder */
  createReminderPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/workspace/${workspaceId}/reminder`);

  /**
   * @description Returns a response with data for a meeting type given tenantId and a slug
   *
   * @tags Meeting Type / Queries
   * @name GetByMeetingTypeSlug
   * @request GET:/v1/public/tenant/{tenantId}/meeting-type-slug/{meeting-type-slug}
   */
  getByMeetingTypeSlug = (
    tenantId: string,
    meetingTypeSlug: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PublicMeetingType,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-type-slug/${meetingTypeSlug}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getByMeetingTypeSlug */
  getByMeetingTypeSlugPathGetter = (
    tenantId: string,
    meetingTypeSlug: string,
    query: {
      /** @pattern [^\s\\/]+ */
      workspaceId: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-type-slug/${meetingTypeSlug}`, query);

  /**
   * @description Returns a map of existing meeting types
   *
   * @tags Meeting Type / Queries
   * @name PublicFindMeetingTypes
   * @request GET:/v1/public/tenant/{tenantId}/meeting-types
   */
  publicFindMeetingTypes = (
    tenantId: string,
    query?: {
      /** List of meeting type ids */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapMeetingTypeIdPublicMeetingType,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-types`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for publicFindMeetingTypes */
  publicFindMeetingTypesPathGetter = (
    tenantId: string,
    query?: {
      /** List of meeting type ids */
      id?: string[];
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-types`, query);

  /**
   * @description Returns a validation result
   *
   * @name ValidatesAMeetingTypePassword
   * @request POST:/v1/public/tenant/{tenantId}/meeting-type/{meetingTypeId}/validate-password
   */
  validatesAMeetingTypePassword = (
    tenantId: string,
    meetingTypeId: string,
    query: {
      /** @minLength 1 */
      password: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MeetingTypePasswordValidation,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting-type/${meetingTypeId}/validate-password`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validatesAMeetingTypePassword */
  validatesAMeetingTypePasswordPathGetter = (
    tenantId: string,
    meetingTypeId: string,
    query: {
      /** @minLength 1 */
      password: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/meeting-type/${meetingTypeId}/validate-password`, query);

  /**
   * @description Force deletes the meeting type using the specified id, ignores acquired leases, dangerous endpoint, use with caution
   *
   * @tags Meeting Type / CRUD
   * @name ForceDeleteMeetingType
   * @request DELETE:/v1/tenant/{tenantId}/dangerous/meeting-type/{meetingTypeId}
   * @secure
   */
  forceDeleteMeetingType = (
    tenantId: string,
    meetingTypeId: string,
    query: {
      force: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/dangerous/meeting-type/${meetingTypeId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for forceDeleteMeetingType */
  forceDeleteMeetingTypePathGetter = (
    tenantId: string,
    meetingTypeId: string,
    query: {
      force: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/dangerous/meeting-type/${meetingTypeId}`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResourceMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @secure
   */
  listResourcesWhichUseThisResourceMethodPut = (
    tenantId: string,
    data: UsageRequestTapirCodecsSchemaForUsageRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseTapirCodecsSchemaForWrappedLeaseRes[],
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResourceMethodPut */
  listResourcesWhichUseThisResourceMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description bulk PUT usages endpoint (GET method with body is not widely supported)
   *
   * @tags Lease
   * @name ListResourcesWhichUseQueriedResourcesMethodPut
   * @request PUT:/v1/tenant/{tenantId}/lease-by-ids
   * @secure
   */
  listResourcesWhichUseQueriedResourcesMethodPut = (
    tenantId: string,
    data: UsageBulkRequestTapirCodecsSchemaForUsageBulkRequestRes,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedLeaseTapirCodecsSchemaForWrappedLeaseRes[],
      | DataFieldRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease-by-ids`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseQueriedResourcesMethodPut */
  listResourcesWhichUseQueriedResourcesMethodPutPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease-by-ids`);
}
